import api from "../../services/api";

export default {
  fetchInvitationVacancyRequested: async ({ commit }, payload) => {
    try {
      const { token, talent_id, utm_source, utm_medium, utm_campaign } = payload;
      
      commit("FETCH_INVITATION_VACANCY_REQUESTED");
      
      const {
        data: { data },
      } = await api.get(`api/v2/applications/invites/${token}`, {
        headers: {
          "X-Api-Key": process.env.VUE_APP_API_KEY,
          "content-type": "application/json",
        },
      });
      
      commit("FETCH_INVITATION_VACANCY_SUCCESS_REQUESTED", data);
    } catch (error) {
      commit("FETCH_INVITATION_VACANCY_FAILURE_REQUESTED", error.response.data.message || error.message);
    }
  },
  onInviteAcceptedRequest: async ({ commit }, payload) => {
    try {
      const { token, talent_id, utm_source, utm_medium, utm_campaign } = payload;

      commit("INVITE_ACCEPTED_REQUEST");

      let queryParams = {
        talent_id: talent_id,
        utm_source: utm_source,
        utm_medium: utm_medium,

      }

      if (utm_campaign !== null) {
        queryParams.utm_campaign = utm_campaign
      }

      queryParams = new URLSearchParams(queryParams).toString();

      const { data } = await api.patch(
        `api/v2/applications/invites/${token}/accept?${queryParams}`,
        null,
        {
          headers: { "X-Api-Key": process.env.VUE_APP_API_KEY },
        }
      );

      commit("INVITE_ACCEPTED_SUCCESS_REQUEST", data);
    } catch (error) {
      commit("INVITE_ACCEPTED_FAILURE_REQUEST", error.message);
    }
  },
  onInviteRefusedRequest: async ({ commit }, payload) => {
    try {
      const { token, talent_id, utm_source, utm_medium, utm_campaign } = payload;

      commit("INVITE_REFUSED_REQUEST");

      let queryParams = {
        talent_id: talent_id,
        utm_source: utm_source,
        utm_medium: utm_medium,

      }

      if (utm_campaign !== null) {
        queryParams.utm_campaign = utm_campaign
      }

      queryParams = new URLSearchParams(queryParams).toString();

      const { data } = await api.patch(
        `api/v2/applications/invites/${token}/refuse?${queryParams}`,
        null,
        {
          headers: { "X-Api-Key": process.env.VUE_APP_API_KEY },
        }
      );

      commit("INVITE_REFUSED_SUCCESS_REQUEST", data);
    } catch (error) {
      commit("INVITE_REFUSED_FAILURE_REQUEST", error.message);
    }
  },
};
